import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Login from './Login';
import UILogin from './Login/index.jsx';
import Profile from "./Profile";
import Register from "./Register";
import Recovery from "./Recovery";

/**
 * Роутер всего приложения
 */

const router = createBrowserRouter([
    // старое апп, которое не надо трогать (перенесем на роут /old-login в связи с переходом на новый ui)
    { path: "/old-login", element: <Login /> },
    { path: "/",          element: <UILogin /> },
    // ниже добавлять другие роуты 
    { path: "/recovery",  element: <Recovery /> },
    { path: "/profile",   element: <Profile /> },
    { path: "/register",  element: <Register /> },

]);

function Router() {
    
    return (
        <RouterProvider router={router} />
    );
}

export default Router;
